import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert } from 'actions/alerts';
import userEmailsKeys from './queryKeys';
export function useAddMyEmail() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    options = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function addMyEmail(_x) {
    return _addMyEmail.apply(this, arguments);
  }
  function _addMyEmail() {
    _addMyEmail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(emails) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('post', '/api/me/email', null, {
              emails: emails
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _addMyEmail.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: addMyEmail
    }, options), {}, {
      onSuccess: function onSuccess() {
        // Confirmation (which emails were added, and that verification
        // is required) is shown by AddEmailModal, not a toast here
        queryClient.invalidateQueries({
          queryKey: userEmailsKeys.userEmails()
        });
      },
      onError: function onError(error, emails) {
        if ((error === null || error === void 0 ? void 0 : error.code) === 'ADDITIONAL_EMAIL_CONFLICT') {
          setAlert({
            title: t('alert_add_email_error_conflict', {
              count: emails.length
            })
          });
          return;
        }
        setAlert({
          title: t('alert_add_email_error', {
            count: emails.length
          })
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    addMyEmail: mutateAsync
  });
}